/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeInvestorCreditSplitGetResponseSchema } from './changeInvestorCreditSplitGetResponseSchema.ts';

export const getChangeInvestorCreditSplitQueryParamsSchema = z.object({
  company: z.string(),
});

/**
 * @description 200 response
 */
export const getChangeInvestorCreditSplit200Schema = z.lazy(() => changeInvestorCreditSplitGetResponseSchema);

/**
 * @description 505 response
 */
export const getChangeInvestorCreditSplit505Schema = z.any();

export const getChangeInvestorCreditSplitQueryResponseSchema = z.lazy(() => getChangeInvestorCreditSplit200Schema);
